/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import { Button } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import ExportButton from "../Components/ExportButton/ExportButton";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import useUserConfig from "../../../hooks/useUserConfig";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  ACTIVE,
  Constants,
  AlertStatus,
} from "../../../contants";
import { MEMBER_SEARCH_COL } from "../../../contants/table/memberSearch";
import useParamsQuery from "../../../hooks/useParamsQuery";
import { SET_SELECTED_MEMBER_TRANSFER } from "../../../redux/actionTypes/dashboard";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
} from "../../../redux/selectors/user";
// import Member from "../../../services/api/member";
import Reports from "../../../services/api/reports";
import { ROUTES } from "../../../utils/constants";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import AdvancedSearch from "./AdvancedSearch";
import styles from "./MemberSearch.styles";
// import MemberTable from "./MemberTable/MemberTable";
import ReportTable from "../Components/ReportsTable/ReportTable";
// import MemberToggleStatus from "./MemberToggleStatus/MemberToggleStatus";
import ReportToggleStatus from "../Components/ReportsToogleStatus/ReportsToggleStatus";
// import OrganizationSearch from "./OrganizationSearch";
import OrganizationSearch from "../Components/OrganizationSearch";
import PersonalDetailsSearch from "../Components/PersonalDetailsSearch";
import {
  getFormattedQuery,
  getRoutePath,
  performOperation,
  getFilters,
  handleDependencyFilter,
} from "./utils";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";

const LOADER_DELAY = 1000;
const PAGE = "page";

const FILTER_KEYS = {
  ADVANCE_FILTER: "advance-filter",
  PERSONAL_FILTER: "personal-filter",
  ORGANISATION_STRUCTURE_FILTER: "orgainsation-structure-filter",
};

const SEARCH_FILTERS = [
  {
    key: FILTER_KEYS.ORGANISATION_STRUCTURE_FILTER,
    component: OrganizationSearch,
    popOverprops: { heading: "Organization Structure", minWidth: 413 },
  },
  {
    key: FILTER_KEYS.PERSONAL_FILTER,
    component: PersonalDetailsSearch,
    popOverprops: {
      heading: "Search by Personal Details",
    },
  },
  {
    key: FILTER_KEYS.ADVANCE_FILTER,
    component: AdvancedSearch,
    popOverprops: {
      heading: "Advanced Search",
    },
  },
];

// const intialPaginationState = {
//   currentPage: 0,
//   totalPages: 0,
//   totalElements: 0,
//   pageSize: Constants.DEFAULT_PAGE_SIZE,
// };
const filterOrder = [
  "areaId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

function MemberSearch() {
  const TITLE = "Member Report - BSG";
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  // const [paginationInfo, setPaginationInfo] = useState(intialPaginationState);
  const [isLoading, setIsLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.newMeta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const { isHelpDesk, isHelpDeskAdmin } = useSelector(selectAllSIUsers);
  const hasPermission = useUserConfig();
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const toast = useContext(ToastAlertContext);
  const [openResultModal, setOpenResultModal] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [showSearchResult, setShowSearchResult] = useState(false);
  const allowModalRef = useRef(false);
  const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);

  const toggleAdvancedSearch = () => {
    setIsAdvancedOpen((prev) => !prev);
  };

  const onModalToggle = () => setOpenModal((prev) => !prev);

  // const updatePaginationInfo = (pagination) => {
  //   setPaginationInfo({
  //     currentPage: pagination.number,
  //     totalPages: pagination.totalPages,
  //     totalElements: pagination.totalElements,
  //     pageSize: pagination.size,
  //   });
  // };

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    // setPaginationInfo(intialPaginationState);
    clearFormRef();
  };
  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["pageNumber", "pageSize"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const validateAndFetchData = (formattedQuery, toast, setIsLoading) => {
    if (
      !formattedQuery.hasOwnProperty("areaId") ||
      formattedQuery.areaId === ""
    ) {
      toast.show("Please enter Area", AlertStatus.ERROR);
      setIsLoading(false);
      return false;
    }

    if (
      formattedQuery.specialGroupAppointments &&
      !formattedQuery.mainlinePositionIds &&
      !formattedQuery.dualPositionIds
    ) {
      toast.show("Please select the positions", AlertStatus.ERROR);
      setIsLoading(false);
      return false;
    }

    return true;
  };

  const fetchSearchData = async (
    queryParams,
    pageNumber = 0,
    pageSize = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      setIsLoading(true);

      const formattedQuery = getFormattedQuery({
        ...queryParams,
        pageNumber,
        pageSize,
      });

      if (validateAndFetchData(formattedQuery, toast, setIsLoading)) {
        const { data } = await Reports.searchMemberReports(formattedQuery);

        if (!data.content || data.content.length === 0) {
          toast.show("No data found.", AlertStatus.ERROR);
          setSearchData([]);
          setOpenResultModal(false); // 🔹 agar data na ho to modal band
          setIsLoading(false);
          return;
        }

        setTimeout(() => {
          setSearchData(data.content);
          setCurrentPage(data.number);
          setTotalPages(data.totalPages);
          setTotalElements(data.totalElements);
          setPageSize(pageSize);
          setIsLoading(false);
          if (allowModalRef.current) {
            setOpenResultModal(true);
            setShowSearchResult(true);
            allowModalRef.current = false;
          }
        }, LOADER_DELAY);
      } else {
        // 🔹 agar filters valid na ho ya empty ho
        setOpenResultModal(false);
      }
    } catch (error) {
      setIsLoading(false);
      setOpenResultModal(false); // 🔹 error aane par bhi modal band
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };

  useEffect(() => {
    const queryObject = getQueryObject();

    if (isEmptyObj(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      return;
    }

    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      setShowSearchResult(false);
      allowModalRef.current = false;
      return;
    }

    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params.pageNumber, params.pageSize);
    initializeFormState(query);
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
    }
  }, [metaData, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      pageNumber: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      pageNumber: 0,
      pageSize: queryObject.pageSize
        ? performOperation(
            queryObject.pageSize,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onSelectMemberForTransfer = (member) => {
    dispatch({
      type: SET_SELECTED_MEMBER_TRANSFER,
      payload: member,
    });
    navigate(ROUTES.MEMBER_TRANSFER_REQUEST.path);
  };

  const onSelectMember = (member) => {
    navigate(`/${ROUTES.REPORTS_MEMBER.path}/${member.memberId}`);
  };

  const onMemberStatusToggle = (member) => {
    setSelectedMember(member);
    onModalToggle();
  };

  const getTitle = () =>
    selectedMember?.status === ACTIVE
      ? "Reason for deactivating the user?"
      : "Reactivation";

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  const checkQueryRoleIds = (query) => {
    if (query.roleIds && query.roleIds.length > 0) {
      return true;
    }
    return false;
  };
  const onSubmit = (e) => {
    e.preventDefault();

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);

    const hasAnyValue = Object.values(formData).some(
      (val) => val?.trim?.() !== ""
    );

    if (!hasAnyValue) {
      toast.show("Please select your search filter.", AlertStatus.WARNING);
      setOpenResultModal(false); // 🔹 filter empty hai to modal band hi rahe
      return;
    }

    const formattedQuery = getFormattedQuery({
      ...formData,
      pageNumber: 0,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
    });

    const isValid = validateAndFetchData(formattedQuery, toast, () => {});
    if (!isValid) {
      setOpenResultModal(false); // 🔹 invalid query ho to bhi modal band
      return;
    }

    const query = queryString.stringify({
      ...formData,
      pageNumber: 0,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
      timestamp: new Date().getTime(),
    });

    setShowSearchResult(true);
    document.dispatchEvent(new Event(EVENT_NAME));
    allowModalRef.current = true;
    updateSearchParam(query); // triggers useEffect + fetchSearchData
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
  };

  const handleResetAndClose = () => {
    updateSearchParam(); // clears filters
    setOpenResultModal(false);
    setSearchData([]);
  };
  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
      pageNumber: 0,
      pageSize: Constants.DEFAULT_PAGE_SIZE,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    // handle dependency filter
    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    // setPaginationInfo(intialPaginationState);
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
  };

  const checkQueryhonoraryDistrictChief = (query) => {
    console.log("Query Object:", query);
    if (query.honoraryDistrictChief) {
      return true;
    }
    return false;
  };

  const queryObject = getQueryObject();
  const [query] = getQueryParams(queryObject);
  const hasRoleIds = checkQueryRoleIds(query);
  const hashonoraryDistrictChief = checkQueryhonoraryDistrictChief(query);
  console.log("data:", hashonoraryDistrictChief);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <div style={styles.container}>
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "0px 10px 2px 10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "0px",
                  paddingBottom: "0px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left cluster: Total + Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>
                    Total Members: {totalElements}
                  </div>
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Clear + Export + Back */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <Button
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </Button>

                  <ExportButton
                    data={searchData}
                    exportFunction={Reports.downloadMembersReport}
                    columnHeadingList={MEMBER_SEARCH_COL}
                    fileName="member_report"
                    buttonProps={{
                      style: { height: "32px" },
                    }}
                  />

                  <Button
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </Button>
                </div>
              </div>

              {/* Table */}
              <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
                <ReportTable
                  searchData={searchData}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  onSelectMemberForTransfer={onSelectMemberForTransfer}
                  onSelectMember={onSelectMember}
                  hasPermission={hasPermission}
                  onMemberStatusToggle={onMemberStatusToggle}
                  showStatusColumn={isHelpDesk || isHelpDeskAdmin}
                  hasRoleIds={hasRoleIds}
                  hashonoraryDistrictChief={hashonoraryDistrictChief}
                />
              </div>

              {/* Pagination */}
              <div style={{ marginTop: "20px" }}>
                <Pagination
                  totalPages={totalPages}
                  totalResults={totalElements}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  onChange={onPaginationClick}
                  onPageSizeClick={onPageSizeClick}
                />
              </div>
            </>
          ) : null}
        </Modal>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </Button>
        </div>
        <div
          style={{
            ...styles.filter,
            flexDirection: "column",
            width: "100%",
          }}
        >
          {/* 🔹 Form fields in vertical layout */}
          <form onSubmit={onSubmit} ref={formRef} style={{ width: "100%" }}>
            {/* 🔹 Organization & Personal Filters */}
            {SEARCH_FILTERS.filter(
              (f) => f.key !== FILTER_KEYS.ADVANCE_FILTER
            ).map(({ component: Component, popOverprops, key }) => (
              <div key={key} style={{ marginBottom: 1 }}>
                <h3
                  style={{
                    fontWeight: "600",
                    fontSize: 16,
                  }}
                >
                  {popOverprops?.heading || "Search Section"}
                </h3>
                <Component
                  formRef={formRef}
                  disabledOSKeys={disabledOSKeys}
                  isMemberReport
                />
              </div>
            ))}
            {/* 🔹 Search Button (Desktop Only) */}
            {!isMobile && (
              <div
                style={{
                  alignSelf: "right",
                  textAlign: "right",
                  marginTop: "10px",
                  marginRight: "5px",
                }}
              >
                <Button type="submit" variant="contained" color="primary">
                  Search
                </Button>
              </div>
            )}

            {/* 🔹 Advanced Search with Expand/Collapse Toggle */}
            <div
              style={{
                cursor: "pointer",
                alignItems: "center",
                fontWeight: "400",
                marginBottom: "8px",
                fontSize: "16px",
                gap: "2px",
              }}
            >
              <button
                type="button"
                onClick={toggleAdvancedSearch}
                style={{
                  all: "unset",
                  fontWeight: "600",
                  fontSize: 16,
                  paddingBottom: 6,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  marginBottom: 12,
                  paddingTop: 12,
                }}
              >
                {isAdvancedOpen ? "-" : "+"} Advanced Search
              </button>

              {isAdvancedOpen && (
                <AdvancedSearch
                  formRef={formRef}
                  disabledOSKeys={disabledOSKeys}
                  isMemberReport
                />
              )}
            </div>

            {/* 🔹 Search Button (Mobile Only - Under Advanced Search) */}
            {isMobile && (
              <div
                style={{
                  display: "flex",
                  justifyContent: isMobile ? "center" : "flex-end",
                  paddingTop: isMobile ? "10px" : "10px",
                  marginRight: isMobile ? "15px" : "10px",
                  paddingBottom: isMobile ? "100px" : "0px",
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  sx={{
                    width: isMobile ? "90%" : "auto",
                  }}
                >
                  Search
                </Button>
              </div>
            )}
          </form>
        </div>
        {/* Mobile separator border - visual boundary */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "15px",
              paddingBottom: "30px",
              marginTop: "10px",
            }}
          />
        )}

        {isLoading && <Loader />}
        <Modal open={openModal} onClose={onModalToggle} title={getTitle()}>
          <ReportToggleStatus
            selectedMember={selectedMember}
            onClose={onModalToggle}
            callBack={onRefresh}
          />
        </Modal>
      </div>
    </>
  );
}

export default MemberSearch;
